var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 196,
    viewBox: "0 0 196 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_415_2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_415_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 70C0 62.268 6.26801 56 14 56H56V168C56 183.465 43.4641 196 28 196C12.536 196 0 183.465 0 168V70Z",
    fill: "url(#paint0_linear_415_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 70C0 62.268 6.26801 56 14 56H56V196H28C12.536 196 0 183.465 0 168V70Z",
    fill: "url(#paint1_linear_415_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 70C0 62.268 6.26801 56 14 56H56V196H28C12.536 196 0 183.465 0 168V70Z",
    fill: "url(#paint2_linear_415_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 14C196 6.26801 189.732 0 182 0H70C62.268 0 56 6.26801 56 14V168C56 183.465 43.4641 196 28 196H168C183.465 196 196 183.465 196 168V14Z",
    fill: "url(#paint3_linear_415_2)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_415_2",
    x1: 6.125,
    y1: 70.2187,
    x2: 83.5068,
    y2: 179.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#4AFF46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#F9FD42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_415_2",
    x1: -36.75,
    y1: 96.4687,
    x2: 14.0096,
    y2: 209.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989477,
    stopOpacity: 0.39
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_415_2",
    x1: -24.3477,
    y1: 146.192,
    x2: 73.4473,
    y2: 151.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.578561,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.53
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_415_2",
    x1: 118.389,
    y1: 1.6001,
    x2: 21.7726,
    y2: 190.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC38FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#FF5A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB13C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_415_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 196,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_415_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 196,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dd8cc3962d504d787d7f5f6cbe202c24.svg";
export { ForwardRef as ReactComponent };